import {
  SuspenseQueryHookOptions,
  skipToken,
  useSuspenseQuery,
} from '@apollo/client'

import {
  OrderRequirementChecksDocument,
  OrderRequirementChecksQuery,
} from '__generated__/atlas-types'

import { atlasClient } from 'graphql/client'

import { useOrderId } from 'features/Orders/orders.hooks'

/**
 * Returns information about if the order has unavailable skus or not.
 *
 *
 * @param orderId - The ID of the order.
 * @returns Boolean indicating if the order has unavailable skus.
 */
export function useHasUnavailableSkus(): boolean {
  const orderId = useOrderId()
  const suspenseQueryOptions = orderId
    ? ({
        client: atlasClient,
        variables: {
          orderIds: [orderId],
        },
        errorPolicy: 'ignore',
      } as SuspenseQueryHookOptions)
    : skipToken

  const { data } = useSuspenseQuery<OrderRequirementChecksQuery>(
    OrderRequirementChecksDocument,
    suspenseQueryOptions,
  )

  return Boolean(data?.orderRequirementChecks?.[0]?.sizeRunChanged)
}
